import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { AsyncSelect, Button, useValidator } from 'components';
import { notifyApiError } from 'components/layout/Toasts';

import { ProductsApi } from 'src/api';
import { AdminApi } from 'src/api';

import { changeProducersVersion } from '../../actions';

import style from './MoveProductsProducer.module.scss';

const MoveProductsProducer = ({ closeModal, producer }) => {
  const dispatch = useDispatch();
  const validator = useValidator();

  const [newProducer, setNewProducer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validator.allValid()) {
      validator.showMessages();
      return;
    }

    const data = {
      producer_id_from: producer.id,
      producer_id_to: newProducer?.id
    };

    try {
      setIsLoading(true);
      await AdminApi.moveProducerProducts(data);
      dispatch(changeProducersVersion());
      closeModal();
    } catch (err) {
      notifyApiError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const producerLabel = (
    <p className={style.label}>
      Przenieś produkty producenta
      <span className={style.producerName}>{producer.producer_name}</span>
      do:
    </p>
  );

  return (
    <form
      className={style.container}
      onSubmit={(e) => handleSubmit(e)}
    >
      <AsyncSelect
        id={'producer-select'}
        name={'producer-select'}
        value={newProducer}
        onChange={(e) => setNewProducer(e, 'producer')}
        apiCallback={ProductsApi.getProducers}
        valueKey={'id'}
        labelKey={'producer_name'}
        label={producerLabel}
        placeholder={'np. 3M'}
        isClearable
        validator={validator}
        rule={'required'}
      />
      <Button
        label={'Przenieś'}
        type={'submit'}
        isLoading={isLoading}
        className={style.button}
      />
    </form>
  );
};

export default MoveProductsProducer;
